import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitFilterPartnerClasses = createSelector(
  [selectFinancialCockpitState],
  ({ filter }) => filter.partnerClasses
)
